import { createRouter, createWebHistory } from 'vue-router'
import HotelMap from '../components/HotelMap.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HotelMap
  },
  {
    path: '/about-site',
    name: 'AboutSite',
    component: HotelMap
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: HotelMap
  },
  {
    path: '/contact',
    name: 'Contact',
    component: HotelMap
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
